import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

import Colours from '/shared/styled/Colours';

function thinnerStyle({ $thinner }: ButtonStyleProps) {
  if ($thinner) {
    return css`
      min-height: 2rem;
      padding-top: 0.6666rem;
      padding-bottom: 0.6666rem;
    `;
  }
}

export default function outlineStyle({ $outline, $inverted, $outlineReplacement, theme }: ButtonStyleProps) {
  if ($outline && $outlineReplacement) {
    return css`
      border: 1px solid transparent;
      color: ${Colours.white} !important;

      &:hover {
        border-color: ${$inverted ? Colours.white : Colours.greenLight2};
        opacity: 0.8;
      }
      ${thinnerStyle}
    `;
  }
  if ($outline && !$outlineReplacement) {
    return css`
      background: ${Colours.white};
      border: 1px solid ${Colours.green};
      color: ${Colours.black} !important;

      &:hover {
        border-color: ${$inverted ? Colours.white : Colours.greenLight2};
        opacity: 0.8;
      }
      ${thinnerStyle}
    `;
  }
}
